/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Frequency from './frequency';
import FrequencyDetail from './frequency-detail';
import FrequencyUpdate from './frequency-update';
import FrequencyDeleteDialog from './frequency-delete-dialog';

const FrequencyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Frequency />} />
    <Route path="new" element={<FrequencyUpdate />} />
    <Route path=":id">
      <Route index element={<FrequencyDetail />} />
      <Route path="edit" element={<FrequencyUpdate />} />
      <Route path="delete" element={<FrequencyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default FrequencyRoutes;
